module.exports = __webpack_public_path__ + "components/MapControl/svg/Cerkiew zabytkowa.svg?9e776364";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Cerkiew zabytkowa.svg
// module id = 1917
// module chunks = 0